<div class="mct-flex mct-row mct-gap-80"  >
  <div class="mct-flex mct-col" >
    <div class="field-column">
      <div>
        <label>{{ 'invoices.invoice-builder.payment-tab.payment-type' | translate | titlecase }}</label>
        <p-select optionLabel="PaymentType" dataKey="PaymentTypeId"
          placeholder="{{ 'invoices.invoice-builder.select-label' | translate }}" [options]="paymentTypes"
          [style]="{ width: '100%' }" [(ngModel)]="selectedPaymentType" (onChange)="paymentTypeChanged($event)"
          [styleClass]="paymentTypeInvalid ? 'error-border' : ''"></p-select>
        <div *ngIf="paymentTypeError" class="warning">
          {{ paymentTypeError }}
        </div>
      </div>
      <div class="mct-flex mct-col" >
        <label>{{ 'invoices.invoice-builder.payment-tab.amount' | translate | titlecase }}</label>
        <input [(ngModel)]="paymentHeader.Amount" type="text" inputmode="numeric" pattern="[0-9]*\.?[0-9]*"
          (keypress)="onlyNumber($event)" (change)="onAmountChange()" />
        <span [hidden]="!overpaying" class="warning">{{ 'invoices.invoice-builder.payment-tab.overpay-message' | translate
          }}</span>
      </div>
      <div>
        <label>{{ 'invoices.invoice-builder.payment-tab.payment-source' | translate | titlecase }}</label>
        <p-select dataKey="PaymentSource" optionLabel="PaymentSource"
          placeholder="{{ 'invoices.invoice-builder.none-label' | translate }}" [style]="{ width: '100%' }"
          [(ngModel)]="selectedPaymentSource" [options]="paymentSources"></p-select>
      </div>
      <div class="mct-flex mct-row mct-gap-7"  >
        <div class="mct-flex mct-col" >
          <label>{{ 'invoices.invoice-builder.payment-tab.payment-date' | translate | titlecase }}</label>
          <wl-date-selector [(ngModel)]="paymentHeader.PaymentDate"></wl-date-selector>
        </div>
        <div class="mct-flex mct-col" >
          <label>{{ 'invoices.invoice-builder.payment-tab.apply-date' | translate | titlecase }}</label>
          <wl-date-selector [(ngModel)]="paymentHeader.ApplyDate"></wl-date-selector>
        </div>
      </div>
      <div class="mct-flex mct-row" >
        <label class="mr-5">{{ 'invoices.invoice-builder.payment-tab.automatic-receipt' | translate | ucfirst }}</label>
        <p-checkbox [(ngModel)]="sendAutomaticReceipt" binary="true"></p-checkbox>
      </div>
    </div>
  </div>
  <div class="field-column">
    <div class="mct-flex mct-row" >
      <div class="mct-flex mct-col" >
        <label>{{ 'invoices.invoice-builder.payment-tab.batch-number' | translate | titlecase }}</label>
        <span><strong>{{ paymentHeader.Batch_Creation }}</strong></span>
      </div>
      <div class="mct-flex mct-col" >
        <label>{{ 'invoices.invoice-builder.payment-tab.batch-number' | translate | titlecase }}</label>
        {{ paymentHeader.PaymentHeaderID }}
      </div>
    </div>
    <div class="mct-flex mct-col" >
      <label>{{ 'invoices.invoice-builder.payment-tab.check-number' | translate | titlecase }}</label>
      <input type="text" [(ngModel)]="paymentHeader.CheckNum" />
    </div>
    <div class="mct-flex mct-col" >
      <label>{{ 'invoices.invoice-builder.payment-tab.reference-number' | translate | titlecase }}</label>
      <input type="text" [(ngModel)]="paymentHeader.Refno" />
    </div>
  </div>
</div>

<div class="mt-50" [hidden]="!showCreditCardInfo">
  <hr />
  <wl-credit-card-input [resolvedGateway]="resolvedGateway" [(ngModel)]="creditCardPayment"></wl-credit-card-input>
</div>
